import { render, staticRenderFns } from "./partner-row.vue?vue&type=template&id=110c3c2c&"
import script from "./partner-row.vue?vue&type=script&lang=js&"
export * from "./partner-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports